<template>
  <div class="navtab_warp">
    <!-- <bannerof
      v-if="navlist !== null && navlist.length > 0"
      style="color: #ffffff"
      :Imgsrc="navlist[0].bannerUrl"
    ></bannerof> -->
    <secondary-banner
      v-if="navlist !== null && navlist.length > 0"
      :title="navlist[0].name"
    ></secondary-banner>
    <div class="library_center secondary_page_bg">
      <div class="inner libraryAlls">
        <ScreenTwo
          v-if="navlist !== null"
          @seldata="seldata"
          @pagedata="pagedata"
          :navlist="navlist"
          :typessel="typessel"
          ref="selchilder"
        ></ScreenTwo>
        <!-- 资源列表 -->
        <div class="emptyall" v-if="filelist == null">
          <el-empty description="资源努力加载中..."></el-empty>
        </div>
        <div class="emptyall" v-else-if="filelist.length == 0">
          <el-empty description="暂无资源"></el-empty>
        </div>
        <div class="modelist" v-else>
          <metail-item :metailList="filelist"></metail-item>
          <div class="pagwarp">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="total"
              :page-size="size"
              :current-page="page"
              @current-change="handleCurrentChange"
              :hide-on-single-page="false"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ScreenTwo from "@/components/screentwo/index.vue";
import { calSize } from "@/utils";
import { TabqueryES, queryES } from "@/api/library";
import { postmeatil } from "@/api/home";
import bannerof from "@/components/bannerof";
import metailItem from "@/components/metailItem/index.vue";
import SecondaryBanner from "@/components/SecondaryBanner";
export default {
  data() {
    return {
      navId: null,
      navlist: null,
      // 资源
      filelist: null,
      typessel: {}, //筛选参数
      total: 0,
      size: 12,
      page: 1,
      baseurl: process.env.VUE_APP_BASE_API,
      keywords: "", //输入框val
      mrimgs: require("@/assets/images/banner.png"),
      mpimg3: require("@/assets/images/mp3img.png"),
      txtimg: require("@/assets/images/textimg.png"),
      mediaType: "", //媒体类型传参
      sortName: "", //排序
      sampleType: "",
      childtype: null, //子集下拉菜单Id
      screnshow: false,
      bannerData: {
        title: "",
        subtit: "",
      },
      seldataObj: {}, //保留初始筛选ES参数
      selgetInd: 0,
      tagNum: 0,
    };
  },
  components: { ScreenTwo, bannerof, metailItem, SecondaryBanner },
  filters: {
    calSize(fileSize) {
      return calSize(fileSize);
    },
  },
  created() {},
  watch: {
    "$store.state.user.navbarList": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (newValue.length > 0) {
          this.$nextTick(() => {
            this.navforEcher();
            console.log(newValue)
          });
        }
      },
    },
    "$store.state.user.tabindex": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        this.page = 1
        if (typeof newValue == "string") {
          this.navId = Number(newValue);
          if (this.$route.query.childtype) {
            this.childtype = this.$route.query.childtype;
          } else {
            this.childtype = null;
          }
          this.$nextTick(() => {
            this.navforEcher();
            
          });
        }
      },
    },
    "$store.state.user.ziId": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (typeof newValue == "string") {
          this.childtype = newValue;
          this.$nextTick(() => {
            this.navforEcher();
            
          });
        }
      },
    },
    "$route.query": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (!newValue.childtype) {
          this.childtype = null;
        } else {
          this.childtype = newValue.childtype;
        }

        this.$nextTick(() => {
          
          this.navforEcher();
        });
      },
    },
  },
  mounted() {
    this.navId = this.$route.query.navId;
    this.$store.commit("user/SET_TABINDEX", this.navId);
    if (this.$route.query.childtype) {
      this.childtype = this.$route.query.childtype;
    } else {
      this.childtype = null;
    }
    this.$nextTick(() => {
      this.navforEcher();
    });
  },
  methods: {
    formatUrl(url) {
      var str = new RegExp("http");
      if (str.test(url)) {
        return url;
      } else {
        return url == null
          ? url
          : url.startsWith("/profile")
          ? this.baseurl + url
          : this.baseurl + "/profile/" + url;
      }
    },
    navforEcher() {
      this.navId = this.$route.query.navId;
      this.typessel = {};
      var navlistall = JSON.parse(JSON.stringify(this.$store.state.user.navbarList));
      if (navlistall.length == 0) {
        return;
      }
      //筛选出来当前tab栏
      this.navlist = navlistall.filter((el) => {
        this.$set(el, "flig", false);
        return this.navId == el.id;
      });
      if (navlistall.length > 0) {
        //给tab底部高亮
        this.$store.commit("user/SET_TABINDEX", this.navlist[0].id);
        //1.筛选出点击的这一模块的类型
        var typeschild = this.navlist[0].children;
        let smallId = [];

        for (let index = 0; index < typeschild.length; index++) {
          let typesItem = typeschild[index];
          if (typesItem.type == 1 && typesItem.types.length > 0) {
            for (let index2 = 0; index2 < typesItem.types.length; index2++) {
              let typebigAll = typesItem.types[index2];
              let keysel = "big" + typebigAll.typeBigId;
              //打上big标识符,用于判断属于哪一个Big
              smallId.push(typebigAll.typeSmallId + "-" + keysel);
              this.typessel[keysel] = [];
            }
          }
        }
        for (let index = 0; index < smallId.length; index++) {
          let splitarr = smallId[index].split("-");
          this.typessel[splitarr[1]].push(splitarr[0]);
        }
        //保留从父类tab栏初进页面的筛选ES参数
        this.seldataObj = JSON.parse(JSON.stringify(this.typessel));
        //2.从tab栏下标进来的筛选出来 那typessel就是 1和2的并集
        //是否从下拉菜单来
        if (this.childtype !== null) {
          this.typessel = {};
          var childrendata = this.navlist[0].children.filter((el) => {
            this.$set(el, "flig", false);
            return this.childtype == el.id;
          });

          this.navlist = childrendata;
          var typechild = childrendata[0].types;
          let smallIdzi = [];

          //typeBigId  typeSmallId
          for (let index = 0; index < typechild.length; index++) {
            let keysel = "big" + typechild[index].typeBigId;
            //打上big标识符,用于判断属于哪一个Big
            smallIdzi.push(typechild[index].typeSmallId + "" + "-" + keysel);
            this.typessel[keysel] = [];
          }
          for (let index = 0; index < smallIdzi.length; index++) {
            let splitarr = smallIdzi[index].split("-");
            this.typessel[splitarr[1]].push(splitarr[0]);
          }

          this.seldataObj = JSON.parse(JSON.stringify(this.typessel));
        } else {
          this.$nextTick(() => {
            this.$refs.selchilder.seltab([]);
          });
        }
      }
      if(!this.$route.query.homeselId){
        this.filelistall(this.keywords);
      }
    },
    //筛选数据
    seldata(data) {
      if (data.status) {
        this.navlist = [];
        let navlistall = JSON.parse(JSON.stringify(this.$store.state.user.navbarList));
        this.navlist = navlistall.filter((el) => {
          this.$set(el, "flig", false);
          return this.navId == el.id;
        });
      } else {
        this.navlist[0].children = data.dataitem.children;
      }
    },
    //详情
    filedetails(id) {
      let rourl;
      if (this.navlist[0].typeShow == 1) {
        rourl = this.$router.resolve({
          path: "/topicDetails",
          query: { id, id, title: "招教题库", tabindex: this.$store.state.user.tabindex },
        });
      } else {
        rourl = this.$router.resolve({
          path: "/library-details",
          query: { id, id, title: "资源列表", tabindex: this.$store.state.user.tabindex },
        });
      }

      this.metailadd(id);
      window.open(rourl.href);
    },
    // 资源列表
    filelistall(keywords, page) {
      if (page !== undefined) {
        this.page = page;
      }
      // 判断 keywords是否有值
      this.keywords = keywords || "";
      // copy筛选列表id
      const typeobj = JSON.parse(JSON.stringify(this.typessel));

      // 获取筛选列表的键
      const keyArr = Object.keys(typeobj);
      // 利用数组的求和方法合并列表的id是否有值
      const newArr = keyArr.reduce(function (prev, curr) {
        return [...prev, ...typeobj[curr]];
      }, []);
      var datas = {
        keywords: this.keywords,
        mediaType: this.mediaType,
        sample: this.sampleType,
        sortName: this.sortName,
        status: 2,
      };
      if (newArr.length > 0) {
        // 有值说明要传types
        var newObj = {};
        for (let key in typeobj) {
          // 循环筛选对象
          if (typeobj[key].length > 0) {
            //去除重复的
            typeobj[key] = [...new Set([...typeobj[key]])];
            // 数组转字符串以空格分隔
            newObj[key] = typeobj[key].join(" ");
          }
        }
        datas = {
          keywords: this.keywords,
          types: newObj,
          mediaType: this.mediaType,
          sample: this.sampleType,
          sortName: this.sortName,
          status: 2,
        };
      }
      TabqueryES(datas, { size: this.size, page: this.page })
        .then((res) => {
          if (res.code == 200) {
            this.filelist = res.rows;
            this.total = res.total;
          }
          this.fullscreenLoading = false;
        })
        .catch((err) => {
          this.fullscreenLoading = false;
        });
    },
    // 资源列表
    filelistallops(keywords, page) {
      if (page !== undefined) {
        this.page = page;
      }
      // 判断 keywords是否有值
      this.keywords = keywords || "";
      // copy筛选列表id
      const typeobj = JSON.parse(JSON.stringify(this.typessel));

      // 获取筛选列表的键
      const keyArr = Object.keys(typeobj);
      // 利用数组的求和方法合并列表的id是否有值
      const newArr = keyArr.reduce(function (prev, curr) {
        return [...prev, ...typeobj[curr]];
      }, []);
      var datas = {
        keywords: this.keywords,
        mediaType: this.mediaType,
        sample: this.sampleType,
        sortName: this.sortName,
        status: 2,
      };
      if (newArr.length > 0) {
        // 有值说明要传types
        var newObj = {};
        for (let key in typeobj) {
          // 循环筛选对象
          if (typeobj[key].length > 0) {
            //去除重复的
            typeobj[key] = [...new Set([...typeobj[key]])];
            // 数组转字符串以空格分隔
            newObj[key] = typeobj[key].join(" ");
          }
        }
        datas = {
          keywords: this.keywords,
          types: newObj,
          mediaType: this.mediaType,
          sample: this.sampleType,
          sortName: this.sortName,
          status: 2,
        };
      }
      queryES(datas, { size: this.size, page: this.page })
        .then((res) => {
          if (res.code == 200) {
            this.filelist = res.rows;
            this.total = res.total;
          }
          this.fullscreenLoading = false;
        })
        .catch((err) => {
          this.fullscreenLoading = false;
        });
    },
    //子组件传的分页数据
    pagedata(val) {
      this.page = val.page;
      if (val.sortName !== undefined) {
        this.sortName = val.sortName;
      }
      if (val.mediaType !== undefined) {
        this.mediaType = val.mediaType;
      }
      if (val.sampleType !== undefined) {
        this.sampleType = val.sampleType;
      }
      if (val.typessel !== undefined) {
        this.typessel = val.typessel;
      }
      if (val.tagId === this.childtype) {
        this.$router.push({
          path: "/navtab?navId=" + this.navId,
        });
      }
      if (val.tagNum == 0) {
        this.tagNum = val.tagNum;
        this.typessel = this.seldataObj;
        this.filelistall(this.keywords);
      } else {
        this.tagNum = 1;
        this.filelistallops(this.keywords);
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.page = val;
      if (this.tagNum == 0) {
        this.filelistall(this.keywords);
      } else {
        this.filelistallops(this.keywords);
      }
    },
    //add素材库浏览量
    metailadd(resourceId) {
      let data = {
        resourceId: resourceId,
      };
      postmeatil(data).then((res) => {});
    },
  },
};
</script>
<style scoped lang="scss">
.library_center {
  padding-bottom: 40px;
  overflow: hidden;
}
.libraryAlls {
  margin-top: 50px;
  padding: 5px 20px;
  border-radius: 8px;
  background-color: #ffffff;
}
/* 资源列表 */
/* 空数据时 */
.emptyall {
  width: 100%;
  height: 500px;
  text-align: center;
}
.modelist {
  margin-top: 17px;
}
.achie_model {
  width: 23%;
  height: 286px;
  border-radius: 10px;
  background-color: #fff;
  overflow: hidden;
  cursor: pointer;
  margin: 12px 1%;
  transition: all 0.4s;
  border: 1px solid #eeeeee;
}

.achie_tops {
  height: 158px;
  border-radius: 3px;
  overflow: hidden;
}

.achie_model:hover {
  box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
}

.achie_model:hover .el-image {
  transform: scale(1.2);
}
.achie_tops > .el-image {
  width: 100%;
  height: 100%;
  transition: all 0.4s;
  font-size: 50px;
  line-height: 150px;
  color: #b3b3b3;
  text-align: center;
}
/* 介绍 */
.achie_text {
  width: 100%;
  font-size: 14px;
  color: gray;
  font-weight: bold;
}
.achiebotms {
  height: 49px;
  line-height: 25px;
  padding: 15px 10px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  border-bottom: 1px solid #f2f2f2;
}
.pcont {
  font-size: 18px;
  color: #181818;
}
.achie_sp {
  width: 100%;
  height: 30px;
  padding: 0 10px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
}

.txtp1,
.txtp2 {
  height: 25px;
}
.txtp1 {
  width: 60%;
  text-align: left;
}
.txtp2 {
  width: 40%;
  text-align: right;
}
.txtp3 {
  width: 55%;
  height: 25px;
}
/* 发布人 */
.creaname {
  width: 45%;
  float: right;
  text-align: right;
  color: #b3b3b3;
}
.txtcolors {
  color: #b3b3b3;
}
/* 分页 */
.pagwarp {
  width: 100%;
  margin: 30px auto;
  text-align: center;
}
</style>
<style lang="scss">
.modelist {
  .metailItemwarp {
    .achie_model {
      .achie_model_inner {
        border: 1px solid #eeeeee;

      }
    }
  }
}
</style>
